<template>
    <div class="footer_compo">
        <div class="footer_content">
            <div>{{ $t('copyright') }}</div>
            <div @click="openTermDialog" style="cursor: pointer">
                <span>{{ $t('termOfUse') }}</span
                >&nbsp;&amp;&nbsp;<span>{{ $t('privacyPolicy') }}</span>
            </div>
        </div>
        <termAndPrivacy ref="tremDialog"></termAndPrivacy>
    </div>
</template>
<script>
import termAndPrivacy from './termAndPrivacy.vue'
export default {
    data() {
        return {}
    },
    components: {
        termAndPrivacy
    },
    methods: {
        openTermDialog() {
            this.$refs.tremDialog.open()
        }
    }
}
</script>
<style lang="scss">
.footer_compo {
    background-color: black;
    height: auto;
    font-size: 12px;
    color: #fff;
    padding: 12px 0;
    .footer_content {
        width: 100%;
        margin: 0 auto;
        text-align: center;
        @media (min-width: 768px) {
            display: flex;
            width: 1200px;
            justify-content: space-between;
        }
    }
}
</style>